import { render } from "./AllIcons.vue?vue&type=template&id=d96df9e4"
import script from "./AllIcons.vue?vue&type=script&lang=js"
export * from "./AllIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__